module.exports = __webpack_public_path__ + "img/used-car-guide-person.d2ac98eb.jpg";